import React from "react"
import feedInfo from "../../assets/images/feedInfo.png"
import feedBoard from "../../assets/images/feedBoard.png"

function EventHeaderFeedBoard({ showToast = { showToast } }) {
    // TODO
    // DEV
    // window.location.href = "celebe://deeplink?feed=920025"
    // KR
    // window.location.href = "celebe://deeplink?feed=10157131"
    // GLOBAL ! PH, TH, ID, IN
    // window.location.href = "celebe://deeplink?feed=10161643"
    const clickHandler = () => {
        window.location.href = window.location.href = "celebe://deeplink?feed=10161643"
    }
    return (
        <div className="event-like-board">
            <img src={feedInfo} alt="Event Feed Info" />
            <img src={feedBoard} alt="Event Feed Board" onClick={clickHandler} />
        </div>
    )
}

export default EventHeaderFeedBoard
